<div class="row pb-5">
   @if ({ observableValue: checkoutService.getFinishingOrder() | async }; as finishingOrder) {
      @if (finishingOrder.observableValue) {
         <app-duck-loader [transparentBackground]="true" [fixed]="true"></app-duck-loader>
      }
   }
   <div class="col-lg-7">
      <div class="checkout-body-content">
         <cx-page-slot position="BodyContent"></cx-page-slot>
      </div>
   </div>
   <div class="col-lg-5">
      <cx-page-slot position="SideContent"></cx-page-slot>
   </div>
</div>
